import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  DictionaryAssetDocumentRequestTypes,
  DictionaryRequestStatus,
} from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';

@Component({
  selector: 'requests-card-view',
  templateUrl: './card-view.component.html',
  styleUrls: ['./card-view.component.scss'],
  standalone: false,
})
export class CardViewComponent {
  public dictionaryRequestStatus = DictionaryRequestStatus;
  public DictionaryAssetDocumentRequestTypes = DictionaryAssetDocumentRequestTypes;

  @Input() requests: app.models.Requests[];
  @Input() props: app.models.DynamicPropsDictionary;
  @Input() viewDetails: any;

  @Output() downloadPolicy: EventEmitter<string> = new EventEmitter<string>();

  downloadHandler(id: string) {
    this.downloadPolicy.emit(id);
  }
}
